<div>
    <full-calendar #calendar [options]="calendarOptions"></full-calendar>
</div>